<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="col-sm-3">
        <v-card>
          <div class="pa-3 mb-4">
            <div class="grey--text overline">{{ $t("currentBalance") }}</div>
            <div class>{{ $t("labelCurrency") }}&nbsp;{{ cash | saldo }}</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="align-center justify-center transparent" elevation="0">
      <v-divider></v-divider>
      <v-row class="py-4">
        <v-col cols="6" class="d-flex">
          <h2>{{ $t("extractByDay") }}</h2>
        </v-col>
        <v-col cols="6">
          <div class="text-right">
            <div>
              <span class="mr-2">{{ $t("previousBalance") }}</span>
              <v-chip
                style="min-width: 80px"
                class="justify-end grey darken-4 font-weight-bold"
                >{{ previousBalance }}</v-chip
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">{{ $t("date") }}</th>
            <th class="text-left">{{ $t("qtdSales") }}</th>
            <th class="text-left">{{ $t("accurate") }}</th>
            <th class="text-left">{{ $t("commissions") }}</th>
            <th class="text-left">{{ $t("cancel") }}</th>
            <th class="text-left">{{ $t("prizes") }}</th>
            <th class="text-left">{{ $t("deal") }}</th>
            <th class="text-right">{{ $t("balanceDay") }}</th>
            <th class="text-right">{{ $t("balanceFinal") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in extract" :key="item.date_entry">
            <td class="text-left">{{ item.date_entry }}</td>
            <td class="text-left">{{ item.count }}</td>
            <td class="text-left">{{ item.sales }}</td>
            <td class="text-left">{{ item.commission }}</td>
            <td class="text-left">{{ item.cancellations }}</td>
            <td class="text-left">{{ item.prizes_paid }}</td>
            <td class="text-left">{{ item.deals }}</td>
            <td class="text-right">{{ item.balance }}</td>
            <td class="text-right">{{ item.balance_final }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  name: "AgentFinancialExtract",
  data: () => ({
    previousBalance: "",
    extract: [],
    cash: "",
  }),
  mounted() {
    this.agentFinancialExtract();
  },
  computed: {
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.agentFinancialExtract();
    },
  },
  methods: {
    agentFinancialExtract() {
      this.$request
        .post("/agent/financial/extract", { ...this.rangeGlobalDate })
        .then((resp) => {
          this.previousBalance = resp.data.dados.balance;
          const respExtract = resp.data.dados.extract;
          this.buildBalance(this.previousBalance, respExtract);
          this.cash = resp.data.credit_current;
        })
        .catch(() => {
          this.extract = [];
        });
    },

    // Build Balance
    buildBalance(previousBalance, respExtract) {
      let extract = [];
      let balance_final = previousBalance;

      let sum = {
        date_entry: "Total",
        count: 0,
        sales: 0,
        commission: 0,
        cancellations: 0,
        prizes_paid: 0,
        deals: 0,
        balance: 0,
        balance_final: 0,
      };

      respExtract.forEach((element) => {
        // sum balance final
        balance_final = Number(element.balance) + Number(balance_final);
        // date treatment
        var dateVal = element.date_entry;
        var date = new Date(`${dateVal}T00:00:00.000`).toLocaleDateString();

        // Assemble item (Row)
        const item = {
          date_entry: date,
          count: element.count,
          sales: element.sales,
          commission: element.commission,
          cancellations: element.cancellations,
          prizes_paid: element.prizes_paid,
          // conditional powerball
          // powerball: element.powerball,
          // cancellations_powerball: element.cancellations_powerball,
          // commission_powerball: element.commission_powerball,
          // prize_powerball: element.prize_powerball,
          deals: element.deals,
          balance: element.balance,
          balance_final: this.decimalAdjustment(balance_final),
        };
        extract.push(item);

        // Sum All Items
        sum.count = sum.count + Number(element.count);
        sum.sales = this.decimalAdjustment(sum.sales + Number(element.sales));
        sum.commission = this.decimalAdjustment(
          sum.commission + Number(element.commission)
        );
        sum.cancellations = this.decimalAdjustment(
          sum.cancellations + Number(element.cancellations)
        );
        sum.prizes_paid = this.decimalAdjustment(
          sum.prizes_paid + Number(element.prizes_paid)
        );
        sum.deals = this.decimalAdjustment(sum.deals + Number(element.deals));
        sum.balance = this.decimalAdjustment(
          sum.balance + Number(element.balance)
        );
        sum.balance_final = this.decimalAdjustment(balance_final);
      });

      extract.push(sum);
      this.extract = extract;
    },

    // Ajust decimal
    decimalAdjustment: function (num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
  },
  filters: {
    saldo: function (value) {
      return value == undefined || value == null
        ? "00,00"
        : Number(value).toLocaleString("pt-BR");
    },
  },
};
</script>
